<p-dialog
      [visible]="visible"
      [modal]="true"
      [dismissableMask]="false"
      [closeOnEscape]="false"
      [closable]="false"
      [position]="'center'"
      [style]="{width: '650px'}"
      [draggable]="false"
      [resizable]="false"
      [header]="'Password Reset Required'"
      styleClass="password-reset-dialog"
      [baseZIndex]="10000">

      <form
        [formGroup]="form"
        class="tw-flex tw-flex-col tw-gap-4 tw-my-4"
        (ngSubmit)="onSubmit()">
        <p class="tw-text-gray-700">
          To continue using your account, you need to create a new password as part of a one-time security update.
          <br/>
          After saving your new password, you'll be signed out and asked to log in again.
        </p>
        <div class="tw-flex tw-flex-col tw-gap-1">
          <label class="tw-text-sm tw-font-medium tw-text-gray-700" for="newPassword">New Password</label>
          <p-password
            inputId="newPassword"
            formControlName="newPassword"
            placeholder="Password"
            [toggleMask]="true"
            [feedback]="false"
            styleClass="tw-w-full"
            inputStyleClass="tw-w-full">
          </p-password>
          <small
            class="tw-text-red-600"
            *ngIf="(submitted || getControl( 'newPassword' )?.touched) && !!getErrorMessage( 'newPassword' )">
            {{ getErrorMessage( 'newPassword' ) }}
          </small>
        </div>

        <div class="tw-flex tw-flex-col tw-gap-1">
          <label class="tw-text-sm tw-font-medium tw-text-gray-700" for="passwordConfirmation">Password Confirmation</label>
          <p-password
            inputId="passwordConfirmation"
            formControlName="passwordConfirmation"
            placeholder="Password"
            [toggleMask]="true"
            [feedback]="false"
            styleClass="tw-w-full"
            inputStyleClass="tw-w-full">
          </p-password>
          <small
            class="tw-text-red-600"
            *ngIf="( submitted || getControl( 'passwordConfirmation' )?.touched ) && !!getErrorMessage( 'passwordConfirmation' )">
            {{ getErrorMessage( 'passwordConfirmation' ) }}
          </small>
        </div>

        <div class="tw-flex tw-justify-end tw-gap-2">
          <button
            type="submit"
            class="btn btn-outline-primary btn-md tw-font-bold"
            [disabled]="form.invalid">
            Reset Password & Logout
          </button>
        </div>
      </form>
    </p-dialog>
